import { render } from "./TodoView.vue?vue&type=template&id=4a05ce56&scoped=true&ts=true"
import script from "./TodoView.vue?vue&type=script&lang=ts"
export * from "./TodoView.vue?vue&type=script&lang=ts"

import "./TodoView.vue?vue&type=style&index=0&id=4a05ce56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a05ce56"]])

export default __exports__